<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class TransferPageMixin extends Vue {
        async loadRuntimeData() {
            const {
                arrivalHotelCode,
                arrivalPlace,
                arrivalCityId,
                arrivalPlaceId,
                departureHotelCode,
                departurePlace,
                departureCityId,
                departurePlaceId,
            } = this.searchRequest
            const promises = []
            if (
                (arrivalHotelCode && arrivalHotelCode !== transfersRuntimeStore.arrivalPoint.hotelCode) ||
                (!arrivalHotelCode &&
                    arrivalPlace === 'hotel' &&
                    arrivalCityId !== transfersRuntimeStore.arrivalPoint.id) ||
                (!arrivalHotelCode &&
                    !['hotel', 'position'].includes(arrivalPlace) &&
                    isNaN(arrivalPlace) &&
                    arrivalPlace !== transfersRuntimeStore.arrivalPoint.iataCode) ||
                (!arrivalHotelCode && !isNaN(arrivalPlace) && arrivalPlace !== transfersRuntimeStore.arrivalPoint.id) ||
                (arrivalPlace === 'position' && arrivalPlaceId !== transfersRuntimeStore.arrivalPoint.placeId)
            ) {
                promises.push(transfersRuntimeStore.loadArrivalPoint(this.searchRequest))
            }
            if (
                (departureHotelCode && departureHotelCode !== transfersRuntimeStore.departurePoint.hotelCode) ||
                (!departureHotelCode &&
                    departurePlace === 'hotel' &&
                    departureCityId !== transfersRuntimeStore.departurePoint.id) ||
                (!departureHotelCode &&
                    !['hotel', 'position'].includes(departurePlace) &&
                    isNaN(departurePlace) &&
                    departurePlace !== transfersRuntimeStore.departurePoint.iataCode) ||
                (!departureHotelCode &&
                    !isNaN(departurePlace) &&
                    departurePlace !== transfersRuntimeStore.departurePoint.id) ||
                (departurePlace === 'position' && departurePlaceId !== transfersRuntimeStore.arrivalPoint.placeId)
            ) {
                promises.push(transfersRuntimeStore.loadDeparturePoint(this.searchRequest))
            }
            await Promise.all(promises)
        }
    }

    export default TransferPageMixin
</script>
